import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { HeartRateIcon } from '@treams/treams-icons';
import { Empty, tokens } from '@treams/treams-ui';

const EmptyCard = styled(Flex)`
	border: 1px solid ${tokens.border.subtle};
	border-radius: 5px;
	align-items: center;
	justify-content: center;
	padding: 32px 0;
	background-color: ${(props) => props.theme.colors.white};
`;

export function DashboardEngagementNoDataAvailable() {
	const { t } = useTranslation();
	return (
		<EmptyCard>
			<Empty title={t('analytics.metric.empty.title')} small={true} icon={<HeartRateIcon />} />
		</EmptyCard>
	);
}
